import { useLocation, useNavigate } from "react-router";
import { PiGhostBold, PiGhostFill } from "react-icons/pi";

import styles from "./IncognitoToggle.module.scss";

export default function IncognitoToggle() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname === "/incognito";

  const handleClick = () => {
    navigate(isActive ? "/" : "/incognito");
  };

  return (
    <button
      className={`${styles.toggle} ${isActive ? styles.active : ""}`}
      onClick={handleClick}
      title="Toggle Incognito Chat"
      aria-label="Toggle Incognito Chat"
    >
      {isActive && <span className={styles.label}>Incognito Chat</span>}
      {isActive ? <PiGhostFill /> : <PiGhostBold />}
    </button>
  );
}
